import React, { ReactElement } from 'react';
import { AuthUser as User } from '../store';
import { Route, RouteElements, RouteRoles } from './index';

export function doesUserHaveAccess(roles?: RouteRoles, user?: User): boolean {
  if (roles && roles.length && user) {
    const roleListString = roles.filter(role => typeof role === 'string') as string[];

    if (roleListString.length && roleListString.includes(user?.role)) {
      return true;
    }

    const roleListFn = roles.filter(role => typeof role === 'function') as ((user: User) => boolean)[];

    if (roleListFn.length && roleListFn.find(role => role(user))) {
      return true;
    }

    return false;
  }

  return true;
}

interface PrivateRouteProps {
  children?: ReactElement | React.ReactNode;

  item?: Route;

  element?: React.ReactNode;

  elements?: RouteElements;
}

function PrivateRoute({ children, item, element, elements }: PrivateRouteProps): React.ReactElement {
  if (item && item.roles) {
    const isBlocked = false;
    let route = item;

    while (route.roles) {
      if (route.parent) {
        route = route.parent;
      } else {
        break;
      }
    }

    if (isBlocked) {
      return <div>Not Found</div>;
    }
  }

  if (elements) {
    if (elements['*']) {
      return elements['*'] as React.ReactElement;
    }

    return <div>Not Found</div>;
  }

  if (element) {
    return element as React.ReactElement;
  }

  return children as React.ReactElement;
}

PrivateRoute.defaultProps = {
  element: undefined,
  elements: undefined,
  item: undefined,
  children: undefined,
};

export default PrivateRoute;
